<template>
  <div class="docs-container">
    <iframe 
      src="/docs/" 
      class="docs-frame"
      title="Documentation"
    ></iframe>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DocsView'
})
</script>

<style scoped>
.docs-container {
  width: 100%;
  height: calc(100vh - 60px); /* Adjust based on your header height */
  position: relative;
}

.docs-frame {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
